import { snakeCase } from 'lodash-es';

/**
 * Walk up the DOM collecting nav segments from [role="menu"] title buttons.
 * For mobile nav - each menu has a title button as its first child.
 *
 * @param {HTMLElement} el - Starting element
 * @returns {string} Path like "shop>sets"
 */
export function getNavPathFromMenuButtons(el) {
  const segments = [];
  let menu = el?.closest('[role="menu"]');

  while (menu) {
    // First button in menu is the title/back button
    const titleBtn = menu.querySelector(':scope > li:first-child > button');
    if (titleBtn) {
      const segment = snakeCase(titleBtn.textContent?.trim());
      if (segment) segments.unshift(segment);
    }
    menu = menu.parentElement?.closest('[role="menu"]');
  }

  return segments.join('>');
}

/**
 * Get nav segment from closest data-nav-segment attribute (for desktop nav).
 *
 * @param {HTMLElement} el - Starting element
 * @returns {string} Segment value or empty string
 */
export function getNavSegmentFromDOM(el) {
  const container = el?.closest('[data-nav-segment]');
  return container?.dataset?.navSegment || '';
}

/**
 * Build the dataLayer payload for a navigation click (DIGITL format).
 *
 * @param {string} area - 'header' or 'footer'
 * @param {string} navigationItemPath - path like "shop>sets>sleep>pillow"
 * @returns {object} Payload for window.dataLayer.push
 */
export function buildNavigationPayload(area, navigationItemPath) {
  const areaLabel = area === 'footer' ? 'Footer' : 'Header';
  return {
    event: 'gaEvent',
    event_name: 'navigation',
    navigation: {
      navigation_area: areaLabel,
      navigation_item: navigationItemPath,
      event_category: 'Navigation',
      event_action: areaLabel,
      event_label: navigationItemPath,
    },
  };
}
